// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/bootstrap/dist/css/bootstrap.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "DM Sans", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f7f8fa;
  color: #444649 !important;
}

:root {
  --primaryColor: #146c94;
  --BackgroundColor: #eeeeee;
}


.mainLayout  {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background-color: #f7f8fa;
}

.LayoutContent {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

.mainContent {
  flex: 1 1;
}

.btn-liveMode {
  border-radius: 8px !important;
  border: 1px solid #eee !important;
  background: #f7f8fa !important;
  color: black;
}

.btn-liveMode:focus {
  background: #f7f8fa !important;
}

.btn-liveMode.Mui-disabled {
  opacity: 0.5; /* Example styling for disabled state */
}

.btn-Waller {
  border-radius: 8px !important;
  border: 1px solid #B9995D !important;
  background: #EAC687 !important;
}

.btn-Waller:focus {
  background: #EAC687 !important;
} 
.btn-Waller1 {
  border-radius: 8px !important;
  border: 1px solid #9A1E1E !important;
  background: #f7f8fa !important;
  color: #9A1E1E;
}

.btn-Waller1:focus {
  background: #EAC687 !important;
} 


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,SAAS;EACT,6CAA6C;EAC7C,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;;AAGA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY,EAAE,uCAAuC;AACvD;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["@import \"~bootstrap/dist/css/bootstrap.css\";\n@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap\");\n\nbody {\n  margin: 0;\n  font-family: \"DM Sans\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #f7f8fa;\n  color: #444649 !important;\n}\n\n:root {\n  --primaryColor: #146c94;\n  --BackgroundColor: #eeeeee;\n}\n\n\n.mainLayout  {\n  display: flex;\n  height: 100vh;\n  overflow: hidden;\n  background-color: #f7f8fa;\n}\n\n.LayoutContent {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.mainContent {\n  flex: 1;\n}\n\n.btn-liveMode {\n  border-radius: 8px !important;\n  border: 1px solid #eee !important;\n  background: #f7f8fa !important;\n  color: black;\n}\n\n.btn-liveMode:focus {\n  background: #f7f8fa !important;\n}\n\n.btn-liveMode.Mui-disabled {\n  opacity: 0.5; /* Example styling for disabled state */\n}\n\n.btn-Waller {\n  border-radius: 8px !important;\n  border: 1px solid #B9995D !important;\n  background: #EAC687 !important;\n}\n\n.btn-Waller:focus {\n  background: #EAC687 !important;\n} \n.btn-Waller1 {\n  border-radius: 8px !important;\n  border: 1px solid #9A1E1E !important;\n  background: #f7f8fa !important;\n  color: #9A1E1E;\n}\n\n.btn-Waller1:focus {\n  background: #EAC687 !important;\n} \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
